import { render, staticRenderFns } from "./ItemUpdateDialogLongDescription.vue?vue&type=template&id=4a8aba89&scoped=true"
import script from "./ItemUpdateDialogLongDescription.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogLongDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8aba89",
  null
  
)

export default component.exports